import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { General, Ingredients } from './subPages'
import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'

const ProductIngredients = props => {
	const [t] = useTranslation()
	const { data, mutations: { updateItem } } = props

	const [linkProd, setLinkProd] = useState(data?.linkProduct ?
		{ id: data.linkProduct?.id, name: data.linkProduct?.name }
		: null
	)


	return(
		<ExpandableBlocks>
			<ContentBlock startExpanded label={t('common.strings.general')}>
				<General {...props} />
			</ContentBlock>
			<ContentBlock label={t('product_section.strings.nutrients')}>
				<Ingredients
					{...props}
					ingredientGroup='nutrients'
					updateMutation={updateItem}
					selectedLinkProduct={linkProd}
					onChangeLinkProduct={val => setLinkProd(val || null)} />
			</ContentBlock>
			<ContentBlock label={t('product_section.strings.allergens')}>
				<Ingredients
					{...props}
					ingredientGroup='allergens_EU'
					updateMutation={updateItem}
					selectedLinkProduct={linkProd}
					onChangeLinkProduct={val => setLinkProd(val || null)} />
			</ContentBlock>
		</ExpandableBlocks>
	)
}

export default ProductIngredients
